<script setup lang="ts">
import Icon from "@/assets/icons/template-icon.svg";

withDefaults(
  defineProps<{
    size?: number | string;
  }>(),
  {
    size: 40,
  }
);
</script>

<template>
  <img class="icon" :src="Icon" alt="DWG Icon" :width="size" />
</template>

<style lang="scss" scoped></style>
